exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".param-table{margin:0 10px}.param-table .el-table th>.cell{line-height:15px}.param-table .el-table tr:hover{background-color:initial}.param-add-button{margin:5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2c0eb8d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/system_config_manage/config_input.vue
// module id = 979
// module chunks = 1